import React from 'react';
// import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import { Avatar, Typography, Box } from '@material-ui/core';
import Icons from '../Icons';

const useStyles = makeStyles(theme => ({
  scoreCard: {
    display: 'flex',
    alignItems: 'center',
    minWidth: theme.spacing(27),
    padding: theme.spacing(1),
    marginTop: theme.spacing(3),
    marginRight: theme.spacing(4)
  },
  scoreCardBody: {
    display: 'flex',
    flexDirection: 'column',
    marginLeft: theme.spacing(1.5)
  },
  scoreCardValue: {
    display: 'flex',
    alignItems: 'center'
  },
  scoreLabel: {
    fontSize: 12,
    color: theme.palette.primary.dataBlack
  },
  scoreValue: {
    fontSize: 16,
    textTransform: 'capitalize'
  },
  scoreCardPeriod: {
    fontSize: 9,
    color: theme.palette.primary.lightBlack,
    marginLeft: theme.spacing(0.5)
  },
  star: {
    width: theme.spacing(4.2),
    height: theme.spacing(4)
  },
  calender: {
    width: theme.spacing(3.6),
    height: theme.spacing(4)
  },
  bookmark: {
    width: theme.spacing(3.6),
    height: theme.spacing(4)
  },
  smiley: {
    width: theme.spacing(4),
    height: theme.spacing(4)
  },
  home: {
    width: theme.spacing(4.1),
    height: theme.spacing(4.2)
  },
  energy: {
    width: theme.spacing(4.2),
    height: theme.spacing(4.1)
  },
  battery: {
    width: theme.spacing(4),
    height: theme.spacing(4.4)
  }
}));

const ScoreCard = props => {
  const classes = useStyles();
  const { value, label, icon, period = '' } = props;
  const Icon = Icons[icon];
  const isValueEmpty = value === undefined || value === null || value === '';
  const cardValue = isValueEmpty ? '-' : value;
  return (
    <Box className={classes.scoreCard}>
      <Avatar variant="square" alt="score-card-label" src={Icon} className={classes[icon]} />
      <Box className={classes.scoreCardBody}>
        <Typography component="div" className={classes.scoreLabel}>
          {label}
        </Typography>
        <Box className={classes.scoreCardValue}>
          <Typography component="div" className={classes.scoreValue}>
            {cardValue}
          </Typography>
          {!isValueEmpty &&
          period && (
            <Typography
              component="div"
              className={classes.scoreCardPeriod}
            >{`( in last ${period} months )`}</Typography>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default ScoreCard;
